import {React, useState, useEffect} from 'react'
import { Box, Tooltip, } from '@mui/material'
import { useTranslate, useRecordContext } from 'react-admin'
import { LoadingButton } from '@mui/lab'
import { PERMISSION_LIST } from 'src/helper/Permission'
import {
  CANCELLED,
  INVOICED,
  DELETED,
  REJECTED,
  PENDING,
  UNPAID,
  PENDING_RESERVATION,
  EXPIRED,
  INVOICE_IN_PROGRESS,
  CANCELLATION_IN_PROGRESS,
} from 'src/components/pages/sales/reservation/logic/common/state'
import { TagsReservation } from 'src/components/pages/sales/reservation/logic/common/TagsReservation'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import {
  PERMISSION_CANCEL,
  PERMISSION_EDIT,
  PERMISSION_ISSUANCE,
  PERMISSION_GUARANTEE,
  PERMISSION_VIEW,
  PERMISSION_MOVE,
  PERMISSION_DELETED,
  PERMISSION_AMEND,
  PERMISSION_RETRIVE,
  PERMISSION_VOID,
} from 'src/helper/Permission'
import { TRAIN_DETAIL_PERMISSION_ENTITY, AIR_DETAIL_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import {itemServices} from 'src/services/reservation/item/item.service.ts'
const PaddingBox = ({ children }) => {
  return <Box paddingX={'10px'}>{children}</Box>
}

export const ToolbarReservation = ({
  resource = 'item',
  onCancel,
  loadingCancelItem,
  onEmit,
  loadingEmitItem,
  labelCancelButton = 'ra.action.cancel',
  onRetrive,
  reservation,
  onDeleted,
  loadingDeleteItem,
  onGuaranteed,
  loadingGuaranteeItem,
  onMove,
  loadingMoveItem,
  setOpenProductModal,
  onEmitStatus,
  loadingEmitStatusItem,
  onCancelStatus,
  loadingCancelStatusItem,
  onRefreshHotel,
  loadingRefreshHotel,
  onClone,
  loadingCloneItem,
  onVoid,
  afterSales,
  onAfterSales,
  loadingAfterSales,
  setLoadingMoveItem,
  setLoadingAfterSalesItem,
  onRegisterReturn,
  postventaStatusButton,
  loadingPostventaStatus,
  loadingRegisterReturn,
  setLoadingRegisterReturn
}) => {
  const translate = useTranslate()
  const product = useRecordContext()
  const [billingStatus, setBillingStatus] = useState()
  
  const isOffline = (product) => {
    return product?.product?.is_offline
  }

  useEffect(()=>{
    if(setLoadingMoveItem){
      setLoadingMoveItem(true)
    }
    if(setLoadingAfterSalesItem){
      setLoadingAfterSalesItem(true)
    }
    if(setLoadingRegisterReturn){
      setLoadingRegisterReturn(true)
    }
    itemServices.get_billing_status(product.hash_).then((res)=>{
      setBillingStatus(res.billable_status)
    }).finally(()=>{
      if(setLoadingMoveItem){
        setLoadingMoveItem(false)
      }
      if(setLoadingAfterSalesItem){
        setLoadingAfterSalesItem(false)
      }
      if(setLoadingRegisterReturn){
        setLoadingRegisterReturn(false)
      }
    })

  },[])

  const isDisabledGuarantee = () => {
    return product?.payment_status !== UNPAID || isOffline(product)
  }
  const isDisabledRetrive = () => {
    if (resource == TRAIN_DETAIL_PERMISSION_ENTITY) {
      const status =
        product?.status === CANCELLED || product?.status === REJECTED || product?.status === EXPIRED
      const has_permission = hasPermissionFunction(TRAIN_DETAIL_PERMISSION_ENTITY, PERMISSION_RETRIVE)
      return status ? !has_permission : status
    }
    if (resource == AIR_DETAIL_PERMISSION_ENTITY) {
      const status = product?.status === INVOICE_IN_PROGRESS
      const has_permission = hasPermissionFunction(AIR_DETAIL_PERMISSION_ENTITY, PERMISSION_RETRIVE)
      return status ? !has_permission : status
    }
    return true //desbilitar si no es las anteriores
  }

  const isDisabledCancel = (product, resource) => {
    if (resource == TRAIN_DETAIL_PERMISSION_ENTITY) {
      return product?.status === CANCELLED || product?.status !== INVOICED
    } else if (resource == AIR_DETAIL_PERMISSION_ENTITY) {
      const status =
        product?.status === INVOICED ||
        product?.status === INVOICE_IN_PROGRESS ||
        product?.status === CANCELLED
      const has_permission = hasPermissionFunction(AIR_DETAIL_PERMISSION_ENTITY, PERMISSION_CANCEL)
      return status ? status : !has_permission
    } else {
      return product?.status === CANCELLED || product?.status === REJECTED
    }
  }

  const showRetriveToRefreshButton = () => {
    try {
      if (resource == AIR_DETAIL_PERMISSION_ENTITY || resource == TRAIN_DETAIL_PERMISSION_ENTITY) {
        return true
      }
      return false
    } catch (error) {
      return false
    }
  }

  const isDisabledVoid = () => {
    if (resource === AIR_DETAIL_PERMISSION_ENTITY) {
      const status = product?.status === INVOICED;
      const createdAt = product?.created_at;
  
      if (createdAt) {
        const createdDate = new Date(createdAt);
        const today = new Date();
  
        // Comparar solo las fechas (ignorando las horas)
        const isToday =
          createdDate.getFullYear() === today.getFullYear() &&
          createdDate.getMonth() === today.getMonth() &&
          createdDate.getDate() === today.getDate();
  
        // Retornar true solo si no es invoiced o no es hoy
        return !(status && isToday);
      }
    }
    
    // Deshabilitar si no es AIR_DETAIL_PERMISSION_ENTITY
    return true;
  };

  return (
    <Box display={'flex'} paddingY={'25px'} marginTop={'10px'}>
      <Box flex={2}>
        <HasPermission permission={PERMISSION_VIEW} resource={'tag'}>
          {product?.tag_relation && (
            <TagsReservation
              tags={product?.tag_relation}
              work_unit_id={reservation.work_unit_id}
              item_id={product?.item_id}
            />
          )}
        </HasPermission>
      </Box>

      <Box flex={1} display={'flex'} justifyContent={'flex-end'}>
        {onGuaranteed && (
          <HasPermission permission={PERMISSION_GUARANTEE} resource={'item'}>
            <PaddingBox>
              <LoadingButton
                variant='contained'
                onClick={() => onGuaranteed(product)}
                disabled={isDisabledGuarantee()}
                loading={loadingGuaranteeItem}
              >
                {translate('ra.action.guarantee')}
              </LoadingButton>
            </PaddingBox>
          </HasPermission>
        )}

        {onRefreshHotel && (
          <HasPermission permission={PERMISSION_DELETED} resource={'item'}>
            <PaddingBox>
              <LoadingButton
                variant='contained'
                onClick={() => onRefreshHotel(product)}
                loading={loadingRefreshHotel}
                disabled={product?.status !== PENDING_RESERVATION && product?.status !== CANCELLATION_IN_PROGRESS}
              >
                {translate('ra.action.update')}
              </LoadingButton>
            </PaddingBox>
          </HasPermission>
        )}

        {onClone && isOffline(product) && (
          <HasPermission permission={PERMISSION_MOVE} resource={'item'}>
            <PaddingBox>
              <LoadingButton
                variant='contained'
                onClick={() => onClone(product)}
                disabled={product.status === 'AFTER_SALES' || product.status === 'AFTER_SALES_HIDDEN'}
                loading={loadingCloneItem}
              >
                {translate('ra.action.clone', { name: 'item' })}
              </LoadingButton>
            </PaddingBox>
          </HasPermission>
        )}

        {onDeleted && isOffline(product) && (
          <HasPermission permission={PERMISSION_DELETED} resource={'item'}>
            <PaddingBox>
              <LoadingButton
                variant='contained'
                color='error'
                onClick={() => onDeleted(product)}
                disabled={product?.status === DELETED}
                loading={loadingDeleteItem}
              >
                {translate('ra.action.delete')}
              </LoadingButton>
            </PaddingBox>
          </HasPermission>
        )}

        {setOpenProductModal && isOffline(product) && (
          <HasPermission permission={PERMISSION_AMEND} resource={'item'}>
            <PaddingBox>
              <LoadingButton
                variant='contained'
                color='success'
                onClick={() => setOpenProductModal && setOpenProductModal(true)}
              >
                {translate('ra.action.edit')}
              </LoadingButton>
            </PaddingBox>
          </HasPermission>
        )}

        {onEmit && (
          <HasPermission permission={PERMISSION_ISSUANCE} resource={resource}>
            <PaddingBox>
              <LoadingButton
                variant='contained'
                className='emit-button'
                onClick={() => onEmit(product)}
                disabled={product?.status !== PENDING}
                loading={loadingEmitItem}
              >
                {translate('ra.action.emit')}
              </LoadingButton>
            </PaddingBox>
          </HasPermission>
        )}

        {onEmitStatus && !isOffline(product) && ( // es para aereos
          <HasPermission permission={PERMISSION_ISSUANCE} resource={resource}>
            <PaddingBox>
              <Tooltip title={translate('ra.tooltip.change_status_to_invoiced')}>
                <LoadingButton
                  variant='contained'
                  className='emit-button'
                  onClick={() => onEmitStatus(product)}
                  disabled={product?.status !== PENDING}
                  loading={loadingEmitStatusItem}
                >
                  {translate('ra.action.emit_status')}
                </LoadingButton>
              </Tooltip>
            </PaddingBox>
          </HasPermission>
        )}

        {onAfterSales && (
          <HasPermission permission={'postventa'} resource={'item'}>
            <PaddingBox>
              <Tooltip >
                <LoadingButton
                  variant='contained'
                  onClick={() => onAfterSales(product)}
                  disabled={billingStatus !== 'BILLED' || product.status === 'AFTER_SALES'}
                  loading={loadingAfterSales}
                >
                  {translate('ra.action.after_sales')}
                </LoadingButton>
              </Tooltip>
            </PaddingBox>
          </HasPermission>
        )} 

        {onRegisterReturn && (
          <HasPermission permission={'postventa_refund'} resource={'item'}>
            <PaddingBox>
              <Tooltip >
                <LoadingButton
                  variant='contained'
                  onClick={() => onRegisterReturn(product)}
                  disabled={billingStatus !== 'BILLED' || product.status === 'AFTER_SALES'}
                  loading={loadingRegisterReturn}
                >
                  {translate('ra.action.register_return')}
                </LoadingButton>
              </Tooltip>
            </PaddingBox>
          </HasPermission>
        )} 

        {onCancel && !isOffline(product) && (
          <HasPermission permission={PERMISSION_CANCEL} resource={'item'}>
            <PaddingBox>
              <LoadingButton
                color='error'
                variant='contained'
                disabled={isDisabledCancel(product, resource)}
                onClick={() => onCancel(product)}
                loading={loadingCancelItem}
              >
                {translate(labelCancelButton)}
              </LoadingButton>
            </PaddingBox>
          </HasPermission>
        )}

        {onCancelStatus && !isOffline(product) && ( // es para aereos
          <HasPermission permission={PERMISSION_CANCEL} resource={'item'}>
            <PaddingBox>
              <Tooltip title={translate('ra.tooltip.change_status_to_cancel')}>
                <LoadingButton
                  color='error'
                  variant='contained'
                  disabled={isDisabledCancel(product, resource)}
                  onClick={() => onCancelStatus(product)}
                  loading={loadingCancelStatusItem}
                >
                  {translate('ra.action.cancel_status')}
                </LoadingButton>
              </Tooltip>
            </PaddingBox>
          </HasPermission>
        )}

        {onMove && (
          <HasPermission permission={PERMISSION_MOVE} resource={'item'}>
            <PaddingBox>
              <LoadingButton 
                variant='contained'  
                onClick={() => onMove(product)} 
                loading={loadingMoveItem}
                disabled={billingStatus === 'BILLED' && 
                  //provisional check of billing module
                    hasPermissionFunction('sales', PERMISSION_LIST)}
              >
                {translate('ra.action.move')}
              </LoadingButton>
            </PaddingBox>
          </HasPermission>
        )}

        <HasPermission permission={PERMISSION_VOID} resource={AIR_DETAIL_PERMISSION_ENTITY}>
          <PaddingBox>
            <LoadingButton 
              color='error' 
              variant='contained' 
              onClick={() => onVoid(product)}
              disabled={isDisabledVoid()}
            >
              {translate('ra.action.void')}
            </LoadingButton>
          </PaddingBox>
        </HasPermission>
    
        {showRetriveToRefreshButton() && (
          <HasPermission permission={PERMISSION_EDIT} resource={'item'}>
            <PaddingBox>
              <LoadingButton
                color='primary'
                variant='contained'
                onClick={() => onRetrive(product)}
                disabled={isDisabledRetrive()}
              >
                {translate('ra.action.refresh_date')}
              </LoadingButton>
            </PaddingBox>
          </HasPermission>
        )}

        {postventaStatusButton &&  (product.status === 'AFTER_SALES_HIDDEN' || product.status === 'AFTER_SALES') &&
          <HasPermission permission='hasEdit' resource={'pricing'}>
            <PaddingBox>
              <LoadingButton
              loading={loadingPostventaStatus}
              onClick={()=>postventaStatusButton(product)}
              sx={{ paddingX: '10px', marginX:'5px' }}
              size='small'
              variant='contained'
              >
              {translate(product.status === 'AFTER_SALES_HIDDEN'?'ra.action.show_aftersales':'ra.action.hide_aftersales')}
              </LoadingButton>
            </PaddingBox>
        </HasPermission>
        }

        {/* <PaddingBox>
          <LoadingButton
            variant='contained'
            style={{ backgroundColor: '#FD6F00' }}
            onClick={() => onReimburse(product)}
            disabled={product?.status === 'CANCELLED'}
            loading={loadingInvocedItem}
          >
            {translate('ra.action.reimburse')}
          </LoadingButton>
        </PaddingBox> */}
      </Box>
    </Box>
  )
}
